/**
 * 방 스케치 세션 - 방 타입 (FigJam 기준)
 */

/** 기본 노출: 현관, 거실, 주방, 방 (각 1개 기본값) */
export const PRIMARY_ROOM_TYPES = [
  { value: 'ENTRANCE' as const, label: '현관' },
  { value: 'LIVING_ROOM' as const, label: '거실' },
  { value: 'KITCHEN' as const, label: '주방' },
  { value: 'ROOM' as const, label: '방' },
] as const;

/** "+ 공간 추가하기"로 추가 가능한 타입 */
export const ADDITIONAL_ROOM_TYPES = [
  { value: 'BATH_ROOM' as const, label: '화장실' },
  { value: 'BALCONY' as const, label: '베란다' },
  { value: 'RESIDENCE_STORAGE' as const, label: '세대창고' },
  { value: 'OTHER_SPACE' as const, label: '기타' },
] as const;

export const ROOM_TYPES = [
  { value: 'ENTRANCE', label: '현관' },
  { value: 'LIVING_ROOM', label: '거실' },
  { value: 'BATH_ROOM', label: '화장실' },
  { value: 'ROOM', label: '방' },
  { value: 'KITCHEN', label: '주방' },
  { value: 'BALCONY', label: '베란다' },
  { value: 'RESIDENCE_STORAGE', label: '세대창고' },
  { value: 'OTHER_SPACE', label: '기타' },
] as const;

export type RoomTypeValue = (typeof ROOM_TYPES)[number]['value'];

export interface HouseSketchRoomInput {
  type: RoomTypeValue;
  count: number;
}

/** 방 스케치 요청 (RoomSketchingRequest) - API 스펙 */
export interface RoomSketchingRequest {
  type: RoomTypeValue;
  namePrefix: string;
  index: number;
}

/** 집 스케치 세션 시작 API 요청 (roomSketchings) */
export interface StartHouseSketchSessionRequest {
  roomSketchings: RoomSketchingRequest[];
}
